import React from "react";
import { Link } from "react-router-dom";
import Navigation from "../components/Navigation";
import { useI18n } from "../i18n/LanguageProvider";
import "../styles/page-accueil.scss";
import "../styles/settings.scss";


const Accueil = () => {
  const { t } = useI18n();

  return (
    <div className="page-accueil">
      <Navigation />

      <main className="container">
        <section className="hero-top" aria-label={t("home.ariaHero")}>
          <div className="hero-text">
            <div className="hero-left">
              <h1 className="titre-principal">{t("home.heroTitle")}</h1>
              <div className="adresse">{t("home.heroAddress")}</div>
            </div>

            <div className="hero-right">
              <div className="date-principale">{t("home.heroSubtitle")}</div>
              <div className="tags">{t("home.heroTagline")}</div>
            </div>
          </div>
        </section>

        <section className="intro-section">
          <div className="col-image">
            <img
              src="/images/banque-photo/img-42.webp"
              alt={t("home.heroImageAlt")}
            />
          </div>

          <div className="col-texte">
            <div className="framed">
              <p>{t("home.introP1")}</p>
              <p>{t("home.introP2")}</p>
              <Link to="/Manifeste" className="cta-arrow">
                {t("home.heroCta")}
              </Link>
            </div>
          </div>
        </section>


      </main>
    </div>
  );
};

export default Accueil;